import k from '../constants/k'
import player from '../components/player'
import arrow from '../components/arrow'
import useInventory from '../components/inventory'
import { mouse, addHoverEffect } from '../components/mouse'
import { addIngredient } from '../components/ingredient'
import book from '../components/book'

k.loadSprite('lake-background', 'sprites/backgrounds/lake.png')

k.loadSprite('waterlilies', 'sprites/ingredients/waterlilies.png')
k.loadSprite('frogs', 'sprites/ingredients/frogs.png')
k.loadSprite('moonsparkles', 'sprites/ingredients/moonsparkles.png', {
  sliceX: 4,
  anims: {
    sparkle: { from: 0, to: 3, loop: true, speed: 2.2 }
  }
})

export default () => {
  k.add([k.sprite('lake-background'), k.area(), 'background'])
  const { cursor } = mouse()
  const inventory = useInventory(cursor)

  const frogs = k.add([
    k.sprite('frogs'),
    k.area(),
    k.pos(20, 82),
    k.scale(1),
    k.anchor('center')
  ])
  addHoverEffect(frogs, cursor)
  frogs.onClick(() => addIngredient(inventory, 'frog'))

  const moonsparkles = k.add([
    k.sprite('moonsparkles'),
    k.area(),
    k.pos(105, 73),
    k.scale(1),
    k.anchor('center'),
    'moonsparkles'
  ])
  moonsparkles.play('sparkle')
  addHoverEffect(moonsparkles, cursor)
  k.onClick('moonsparkles', () => addIngredient(inventory, 'moonwater'))

  const waterlilies = k.add([
    k.sprite('waterlilies'),
    k.area(),
    k.pos(150, 60),
    k.scale(1),
    k.anchor('center')
  ])
  addHoverEffect(waterlilies, cursor)
  waterlilies.onClick(() => addIngredient(inventory, 'waterlily'))

  player()
  arrow('left', 'forest', cursor)
  book(cursor)
}
